import { CheckCircle2, ChefHat, Clock3, Flame, Play } from 'lucide-react'
import StaffShell from '../components/StaffShell'
import { elapsedSince, formatElapsed } from '../components/StatusPill'
import { useLamsa } from '../context/LamsaContext'
import type { Order } from '../types'

export default function BohPage() {
  const { orders, updateOrderStatus } = useLamsa()
  const { staffProfile } = useLamsa()
  if (!staffProfile || !['owner','manager','supervisor','boh'].includes(staffProfile.role)) return <StaffShell title="Back of House"><div className="panel empty-panel big">This role does not have Back of House access.</div></StaffShell>
  const active = orders.filter((o) => ['confirmed','preparing','ready'].includes(o.status))
  const columns = [
    { key: 'confirmed', label: 'NEW', icon: Play },
    { key: 'preparing', label: 'PREPARING', icon: Flame },
    { key: 'ready', label: 'READY', icon: CheckCircle2 },
  ] as const

  return <StaffShell title="Back of House">
    <div className="boh-header-strip"><div><ChefHat /><span>Kitchen production view</span></div><div><Clock3 /><span>Normal &lt; 10m · Warning 10–15m · Critical 15m+</span></div></div>
    <div className="kitchen-board">
      {columns.map((column) => {
        const Icon = column.icon
        const list = active.filter((order) => order.status === column.key)
        return <section className={`kitchen-column ${column.key}`} key={column.key}>
          <header><div><Icon size={18} /><strong>{column.label}</strong></div><span>{list.length}</span></header>
          <div className="kitchen-card-list">
            {list.length === 0 ? <div className="kitchen-empty">Queue clear</div> : list.map((order) => <KitchenCard key={order.id} order={order} onAdvance={() => void updateOrderStatus(order.id, column.key === 'confirmed' ? 'preparing' : column.key === 'preparing' ? 'ready' : 'served')} />)}
          </div>
        </section>
      })}
    </div>
  </StaffShell>
}

function KitchenCard({ order, onAdvance }: { order: Order; onAdvance: () => void }) {
  const elapsed = elapsedSince(order.preparingAt ?? order.acceptedAt ?? order.createdAt)
  const urgency = elapsed >= 900 ? 'critical' : elapsed >= 600 ? 'warning' : 'normal'
  return <article className={`kitchen-ticket ${urgency}`}>
    <div className="ticket-top"><div><span>TABLE</span><strong>{order.tableNumber}</strong></div><div className="ticket-timer"><Clock3 size={15} /><b>{formatElapsed(elapsed)}</b><small>{urgency}</small></div></div>
    <div className="ticket-items">{order.items.map((item) => <div key={item.id}><strong>{item.quantity}×</strong><span>{item.name}</span>{item.guestName && <small>{item.guestName}</small>}</div>)}</div>
    {order.notes && <p className="ticket-note">NOTE · {order.notes}</p>}
    <button onClick={onAdvance}>{order.status === 'confirmed' ? 'START' : order.status === 'preparing' ? 'MARK READY' : 'SERVED'}</button>
  </article>
}
